var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:[
    // Base
    'v-card',
    'd-flex',

    // Background variant
    _vm.bgVariantOutput.class && ("bg-" + (_vm.bgVariantOutput.class)),

    // Overlay
    {
      'v-card--overlay': _vm.overlay
    },

    // Image position
    {
      // Small breakpoint
      'flex-column': !_vm.imgPosition || _vm.imgPosition === 'top',
      'flex-row': _vm.imgPosition === 'left',
      'flex-row-reverse': _vm.imgPosition === 'right',

      // Medium breakpoint
      'flex-md-column': _vm.imgMdPosition === 'top',
      'flex-md-row': _vm.imgMdPosition === 'left',
      'flex-md-row-reverse': _vm.imgMdPosition === 'right',

      // Large breakpoint
      'flex-lg-column': _vm.imgLgPosition === 'top',
      'flex-lg-row': _vm.imgLgPosition === 'left',
      'flex-lg-row-reverse': _vm.imgLgPosition === 'right'
    }
  ],style:({
    backgroundColor: _vm.bgVariantOutput.color
  })},[(_vm.overlay)?_c('div',{class:[
      'v-card__overlay'
    ],style:({
      backgroundImage: !!_vm.imgSrc && ("url('" + _vm.imgSrc + "')"),
      backgroundPosition: !!_vm.imgAlign && _vm.imgAlign
    })},[(!!_vm.imgSrc)?_c('div',{class:[
        'v-card__overlay__color-1',
        _vm.bgVariantOutput.class && ("text-" + (_vm.bgVariantOutput.class))
      ],style:({
        color: _vm.bgVariantOutput.color,
        backgroundImage: !!_vm.imgSrc && "linear-gradient(90deg, currentColor, currentColor 5%, rgba(0,0,0,0))",
        backgroundPosition: !!_vm.imgAlign && _vm.imgAlign
      })}):_vm._e(),(!!_vm.imgSrc)?_c('div',{class:[
        'v-card__overlay__color-2',
        _vm.bgVariantOutput.class && ("text-" + (_vm.bgVariantOutput.class))
      ],style:({
        color: _vm.bgVariantOutput.color,
        backgroundImage: !!_vm.imgSrc && "linear-gradient(-180deg, currentColor, currentColor 5%, rgba(0,0,0,0))",
        backgroundPosition: !!_vm.imgAlign && _vm.imgAlign
      })}):_vm._e()]):_vm._e(),(!!_vm.imgSrc)?_c('div',{class:['v-card__image'],style:({
      backgroundImage: !_vm.overlay && !!_vm.imgSrc && ("url('" + _vm.imgSrc + "')"),
      backgroundPosition: !!_vm.imgAlign && _vm.imgAlign,
    })}):_vm._e(),_c('div',{class:['v-card__content']},[_c('div',{class:['p-4', { 'py-5': !!_vm.imgSrc }]},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }